import React, { useEffect, useState } from 'react';
import Papa from 'papaparse';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import './TopGoalscorers.css';

function TopGoalscorers() {
    const [data, setData] = useState([]);
    const [error, setError] = useState(null);
    const [showLast10, setShowLast10] = useState(true); // Toggle state

    useEffect(() => {
        fetch('/data/player_statistics.csv')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.text();
            })
            .then(csvText => {
                if (csvText.startsWith('<!DOCTYPE html>')) {
                    throw new Error('Received HTML instead of CSV');
                }
                Papa.parse(csvText, {
                    header: true,
                    complete: (result) => {
                        setData(result.data);
                    }
                });
            })
            .catch(error => {
                setError(error.message);
            });
    }, []);

    if (error) {
        return <div>Error: {error}</div>;
    }

    const sortedData = [...data].sort((a, b) => {
        const key = showLast10 ? "Tore\n(Letzten10)" : "Tore\n(Gesamt)";
        const goalsA = parseFloat(a[key]?.replace(',', '.') || 0);
        const goalsB = parseFloat(b[key]?.replace(',', '.') || 0);
        return goalsB - goalsA;
    });

    const maxGoals = Math.max(...sortedData.map(d => {
        const key = showLast10 ? "Tore\n(Letzten10)" : "Tore\n(Gesamt)";
        const goalsStr = d[key];
        if (goalsStr) {
            const goals = parseFloat(goalsStr.replace(',', '.'));
            return isNaN(goals) ? 0 : goals;
        }
        return 0;
    }));

    const handleToggle = (event, newValue) => {
        if (newValue !== null) {
            setShowLast10(newValue === 'last10');
        }
    };

    return (
        <div className="top-goalscorers">
            <h1>Torjäger</h1>
            <ToggleButtonGroup
                value={showLast10 ? 'last10' : 'allTime'}
                exclusive
                onChange={handleToggle}
                aria-label="Score Toggle"
            >
                <ToggleButton value="last10" aria-label="Last 10 Games">
                    Last 10 Games
                </ToggleButton>
                <ToggleButton value="allTime" aria-label="All-Time Scores">
                    All-Time Scores
                </ToggleButton>
            </ToggleButtonGroup>
            <div style={{ width: '100%', height: '600px', overflowY: 'scroll' }}>
                <ResponsiveContainer width="100%" height={800}>
                    <BarChart
                        data={sortedData}
                        layout="vertical"
                        margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                        animationDuration={2000}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis type="number" domain={[0, maxGoals]} />
                        <YAxis type="category" dataKey="Spieler" />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey={showLast10 ? "Tore\n(Letzten10)" : "Tore\n(Gesamt)"} fill="#1e90ff" />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}

export default TopGoalscorers;